/**
 * Lazy Entity References - Handles circular dependencies while preserving types
 *
 * This module provides typed lazy references to entity definitions that can be used
 * to break circular import dependencies while maintaining full TypeScript type inference.
 *
 * Only includes lazy getters that are actually used to break circular deps:
 * - User <-> BotConfig (bidirectional)
 * - User <-> ExchangeAccount (via BotConfig)
 */
// ============================================================================
// Lazy Entity Getters - Runtime functions with proper return types
// ============================================================================
/** Lazily get UserEntityDef (breaks circular import) */
export const getLazyUserEntityDef = () => {
    const { UserEntityDef } = require("./user.entity");
    return UserEntityDef;
};
/** Lazily get BotConfigEntityDef (breaks circular import) */
export const getLazyBotConfigEntityDef = () => {
    const { BotConfigEntityDef } = require("./bot-config.entity");
    return BotConfigEntityDef;
};
